export enum ErrorsEnum {
  CARRIER_NOT_FOUND = 'CARRIER_NOT_FOUND',
  DRIVER_NOT_FOUND = 'DRIVER_NOT_FOUND',
  CLIENT_NOT_FOUND = 'CLIENT_NOT_FOUND',

  DOMAIN_UNIQUE = 'DOMAIN_UNIQUE',
  POLICY_UNIQUE = 'POLICY_UNIQUE',
  VTV_UNIQUE = 'VTV_UNIQUE',

  CHASSIS_UNIQUE = 'CHASSIS_UNIQUE',
  MOTOR_UNIQUE = 'MOTOR_UNIQUE',
  SAME_MOTOR_CHASSIS = 'SAME_MOTOR_CHASSIS',

  MAIL_UNIQUE = 'MAIL_UNIQUE',
  _UNIQUE = 'DNI_UNIQUE',
  LICENSE_UNIQUE = 'LICENSE_UNIQUE',

  VEHICLE_NOT_FOUND = 'VEHICLE_NOT_FOUND',
  VEHICLE_OWNER_NOT_FOUND = 'VEHICLE_OWNER_NOT_FOUND',
  COMPLETE_REQUIRED_FIELDS = 'COMPLETE_REQUIRED_FIELDS',
  
  TRAVEL_INVALID_STATE = 'TRAVEL_INVALID_STATE',
  TRAVEL_WITHOUT_CANDIDATES = 'TRAVEL_WITHOUT_CANDIDATES',
  DRIVER_IS_NOT_AVAILABLE = 'DRIVER_IS_NOT_AVAILABLE',
  DRIVER_WITHOUT_VEHICLE = 'DRIVER_WITHOUT_VEHICLE',
  DRIVER_NOT_ACCEPT_PAYMENT_METHOD = 'DRIVER_NOT_ACCEPT_PAYMENT_METHOD',
  ADMIN_NOT_FOUND = 'ADMIN_NOT_FOUND',
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  USER_NOT_AUTHORIZED = 'USER_NOT_AUTHORIZED',
  INVALID_RESET_PASSWORD_TOKEN = 'INVALID_RESET_PASSWORD_TOKEN',
  INVALID_CURRENT_PASSWORD = 'INVALID_CURRENT_PASSWORD',
  PHONE_UNIQUE = 'PHONE_UNIQUE',

  CONTRACTOR_FANTASY_NAME_UNIQUE = 'CONTRACTOR_FANTASY_NAME_UNIQUE',
  CONTRACTOR_TRIBUTE_NUMBER_UNIQUE = 'CONTRACTOR_TRIBUTE_NUMBER_UNIQUE',

  SOLICITUD_ALREADY_COMPLETED = 'SOLICITUD_ALREADY_COMPLETED',
  CARRIER_SOLICITUDE_NOT_FOUND = 'CARRIER_SOLICITUDE_NOT_FOUND',
  INVALID_SOLICITUDE_TOKEN = 'INVALID_SOLICITUDE_TOKEN',
  SOLICITUDE_ALREADY_WAS_CONFIRMED = 'SOLICITUDE_ALREADY_WAS_CONFIRMED',
  SOLICITUDE_REGION_UNAVAILABLE = 'SOLICITUDE_REGION_UNAVAILABLE',
  SOLICITUDE_INVALID_STATE = 'SOLICITUDE_INVALID_STATE',
  DRIVERS_NOT_AVAILABLE = 'DRIVERS_NOT_AVAILABLE',
  DRIVER_IN_TRAVEL = 'DRIVER_IN_TRAVEL'

}
